import { Button, Col, Input, Modal, notification, Row, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { ColorRing } from "react-loader-spinner";
import { useSelector } from "react-redux";
import { decryptAES, encryptAES } from "../../../redux/middleware/encryptPayloadUtils";
import useApiInterceptor from "../../../hooks/useInterceptor";
import { fetchLocationData } from "../../Location/api/useGetlocation";
import { openNotification } from "../../Auth/utils/Notification";

const EditModal = ({ modalOpen, setModalOpen, loader ,userDetails, handleGetUserData }) => {


  const apiInterceptor = useApiInterceptor();
    const [api, contextHolder] = notification.useNotification();
  

  const accessToken = useSelector((state) => state.auth.authData[0].accessToken);
  const currentUserData = useSelector((state) => state.user.userData[0]);

  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    employee_id: "",
    plant: null,
    role: null,
  });

  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    employee_id: "",
    plant: "",
    location: "",
    role: "",
  });

  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedPlant, setSelectedPlant] = useState(null);

  const [plants, setPlants] = useState([]);
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    if (userDetails && Object.keys(userDetails).length > 0) {
      setData({
        first_name: (userDetails.first_name || "").toLowerCase(),
        last_name: (userDetails.last_name || "").toLowerCase(),
        phone_number: userDetails.phone_number || "",
        email: (userDetails.email || "").toLowerCase(),
        employee_id: (userDetails.employee_id || "").toUpperCase(),
        plant: userDetails.plant_id || null,
        role: (userDetails.role_name ?? "").toLowerCase(),
      });
  
      setSelectedRole((userDetails.role_name ?? "").toLowerCase() || null);
      setSelectedLocation(userDetails.location_id || null);
      setSelectedPlant(userDetails.plant_id || null);

      if (userDetails.location_id) {
        fetchPlantData(userDetails.location_id);
      }
    }
  }, [userDetails]);

console.log(userDetails,"<<<")
  useEffect(() => {
    fetchLocationData(accessToken, apiInterceptor)
      .then((results) => {
        if (results && Array.isArray(results)) {
          setLocations(results)
        } else {
          console.log("No location data found.");
        }
      })
      .catch((err) => {
        console.log("Error in fetching location data:", err);
      });

  }, []);

  const fetchPlantData = async (locationId) => {
    try {
      if (!accessToken || !locationId) return;

      const encryptedLocationId = encryptAES(JSON.stringify(locationId));
      const res = await apiInterceptor.get(`/plant/?location_id=${encryptedLocationId}`);
      const { results } = res.data;

      if (results) setPlants(results);
    } catch (err) {
      console.error("Error fetching plant data:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setError((prev) => ({ ...prev, [name]: "" }));

    if (name === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      setError((prev) => ({
        ...prev,
        email: !emailRegex.test(value) ? "Enter Valid Email" : "",
      }));
    }
    
    setData((prev) => ({ ...prev, [name]: value.replace(/\s/g, "") }));
  };


  const handleRoleChange = (value) => {
    setSelectedRole(value);
    setSelectedLocation(null);
    setSelectedPlant(null);
    setError((prev) => ({ ...prev, role: "" }));
  };

  const handleLocationChange = (value) => {
    setSelectedLocation(value);
    setSelectedPlant(null);
    fetchPlantData(value);
    setError((prev) => ({ ...prev, location: "" }));
  };

  const handlePlantChange = (value) => {
    setSelectedPlant(value);
    setError((prev) => ({ ...prev, plant: "" }));
  };

  const closeModalUser = () => {
    setModalOpen(false);
    setData({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      employee_id: "",
      plant: null,
      role: null,
    });
    setError({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      employee_id: "",
      plant: "",
      location: "",
      role: "",
    });
    setSelectedLocation(null);
    setSelectedRole(null);
    setSelectedPlant(null);
  };


  const resetForm = () => {
    setData({
      first_name: "",
      last_name: "",
      phone_number: "",
      email: "",
      employee_id: "",
      plant: null,
      role: null,
    });
    //setLoading((prev) => ({ ...prev, createUser: true }));

    setError({});
  };


  console.log(selectedRole,"selectedRole")

  const handleUpdateUser = async () => {
    try {
      const emailPattern = /^[a-zA-Z\d._%+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

      const validateRequired = (field, fieldName) => {
        return !field ? `*Please Enter ${fieldName}` : null;
      };

      const validatePhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return "*Please Enter Phone Number";

        const phoneRegex = /^[6-9]\d{9}$/; // Regex to validate Indian mobile numbers starting with 6-9 and 10 digits long
        return !phoneRegex.test(phoneNumber)
          ? "*Please Enter Valid Phone Number"
          : null;
      };

      const validateEmail = (email) => {
        if (!email) return "*Please Enter Email";
        return !emailPattern.test(email) ? "*Please Enter Valid Email" : null;
      };
 
      let errors = {};
      // Validate fields
      errors.firstName = validateRequired(data.first_name, "First Name");
      errors.lastName = validateRequired(data.last_name, "Last Name");
      errors.phone = validatePhoneNumber(data.phone_number);
      errors.email = validateEmail(data.email);
      errors.employee_id = validateRequired(data.employee_id, "Employee ID");
      errors.location = validateRequired(selectedLocation, "Location");
      errors.role = validateRequired(selectedRole, "Role");

      if (
        currentUserData.roleName === "General Manager" &&
        selectedRole === "Manager"
      ) {
        setError((prev) => ({ ...prev, Plant: "" }));
      }
      
      else if( selectedRole === "Manager"){
        setError((prev) => ({ ...prev, Plant: "" }));
      }
      else{
        errors.plant = validateRequired(selectedPlant, "Plant");
      }
      
      // Remove any null values (empty error messages)
      errors = Object.fromEntries(
        Object.entries(errors).filter(([_, v]) => v !== null)
      );
      console.log(errors, "errors");
      setError(errors); // Update errors

      // If there are any errors, stop execution
      if (Object.keys(errors).length > 0) {
        //setLoading((prev) => ({ ...prev, createUser: false }));
        return;
      }

      // Create payload
      const payload = {
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        phone_number: data.phone_number,
        employee_id: (data.employee_id || "").toString().toUpperCase(),
        role_id:
          selectedRole === "Manager" ? 2 : selectedRole === "user" ? 3 : null,
        location_id:
        currentUserData.roleName === "Manager"
        ? currentUserData.locationId
        : selectedLocation,
        plant_id: selectedPlant,
      };

      // Encrypt the payload
      // const encryptedData =  encryptAES(JSON.stringify(payload));
      // const usersPayload = {
      //   data: payload,
      // };
      // Set loading state and make the API request
      //setLoading((prev) => ({ ...prev, createUser: true }));
      const postRequest = await apiInterceptor.put(
        `user/${userDetails.id}/`,
        payload,
      );
      // On successful request, handle success
      if (postRequest.status == 200) {
   
        closeModalUser();
        setModalOpen(false);

        handleGetUserData()
        openNotification(
        "success",
         postRequest.data.message,
        );
        resetForm();

      }
    } catch (error) {
      // Handle error response
      // //setLoading((prev) => ({ ...prev, createUser: false }));

      if (error?.response?.message === "Token is invalid or expired") {
        openNotification(
       "error",
      "Unable to create user, Please Try again!",
        );
      } else {
        openNotification(
   "error",
         error?.response?.data?.message,
        );
      }
    }
  };

  if (!userDetails || Object.keys(userDetails).length === 0) return null;

  return (
    <Modal
      title={<div style={{ textAlign: "center", fontSize: "1.3rem" }}>Edit User</div>}
      centered
      open={modalOpen}
      onCancel={closeModalUser}
      footer={null}
      maskClosable={false}
    >
      {loader ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            minHeight: "250px",
            alignItems: "center",
          }}
        >
          <ColorRing
            height="80"
            width="80"
            ariaLabel="color-ring-loading"
            colors={["#F55027", "#F55027", "#F55027", "#BC1C57", "#BC1C57"]}
          />
        </div>
      ) : (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              padding: "1rem",
              fontWeight: "600",
            }}
          >
            <Input
              autoComplete="off"
              placeholder="*Enter First Name"
              type="text"
              name="first_name"
              value={data.first_name}
              onChange={handleChange}
              className="p-2 custom-input"
            />
            {error.firstName && <span style={{ color: "red" }}>{error.firstName}</span>}

            <Input
              autoComplete="off"
              placeholder="*Enter Last Name"
              type="text"
              name="last_name"
              value={data.last_name}
              onChange={handleChange}
              className="p-2 custom-input"
            />
            {error.lastName && <span style={{ color: "red" }}>{error.lastName}</span>}

            <Input
              autoComplete="off"
              placeholder="*Enter Phone Number"
              type="number"
              name="phone_number"
              value={data.phone_number}
              onChange={handleChange}
              className="p-2 custom-input"
            />
            {error.phone && <span style={{ color: "red" }}>{error.phone}</span>}

            <Input
              autoComplete="off"
              placeholder="*Enter Email"
              type="text"
              name="email"
              value={data.email}
              onChange={handleChange}
              className="p-2 custom-input"
            />
            {error.email && <span style={{ color: "red" }}>{error.email}</span>}

            <Input
              autoComplete="off"
              placeholder="*Enter Employee ID"
              type="text"
              name="employee_id"
              value={(data.employee_id || "").toUpperCase()}
              onChange={handleChange}
              className="p-2 custom-input"
            />
            {error.employee_id && <span style={{ color: "red" }}>{error.employee_id}</span>}

            <Select
              size="large"
              placeholder="Select Role*"
              value={selectedRole}
              onChange={handleRoleChange}
              style={{ width: "100%" }}
            >
              {currentUserData.roleName === "General Manager" && (
                <>
                  <Select.Option value="manager">Manager</Select.Option>
                  <Select.Option value="user">User</Select.Option>
                </>
              )}
              {currentUserData.roleName === "Manager" && (
                <Select.Option value="user">User</Select.Option>
              )}
            </Select>
            {error.role && <span style={{ color: "red" }}>{error.role}</span>}

            {currentUserData.roleName === "General Manager" &&
              (selectedRole === "manager" || selectedRole === "user") && (
                <>
                  <Select
                    size="large"
                    placeholder="Select Location*"
                    value={selectedLocation}
                    onChange={handleLocationChange}
                    style={{ width: "100%" }}
                  >
                    {locations.map(({ id, name }) => (
                      <Select.Option key={id} value={id}>
                        {name}
                      </Select.Option>
                    ))}
                  </Select>
                  {error.location && <span style={{ color: "red" }}>{error.location}</span>}
                </>
              )}

            {((currentUserData.roleName === "manager" && selectedRole) ||
              (selectedRole && selectedLocation)) &&
              selectedRole !== "manager" && (
                <>
                  <Select
                    size="large"
                    placeholder="Select Plant*"
                    value={selectedPlant}
                    onChange={handlePlantChange}
                    style={{ width: "100%" }}
                  >
                    {plants.map(({ id, plant_name }) => (
                      <Select.Option key={id} value={id}>
                        {plant_name}
                      </Select.Option>
                    ))}
                  </Select>
                  {error.plant && <span style={{ color: "red" }}>{error.plant}</span>}
                </>
              )}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", padding: "1rem" }}>
            <Button
              className="commButton"
              type="primary"
              style={{ width: "20%" }}
              danger
              onClick={handleUpdateUser} 
            >
              Submit
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};

export default EditModal;
